/**
 * API client for the pre-call briefing (`crm-calls/dial.routes.ts`).
 *
 * Its own file rather than more of `callPilot.ts`, and the split IS the feature:
 * what our scanner found on their site and what the register says about them is
 * not AI, it was never AI, and it should not be behind an "AI is switched off"
 * warning. The fact SHAPE is still the server's `PilotFact`, imported rather
 * than copied so the two panels cannot start drawing different things.
 */
import { api } from "./api";
import type { PilotFact } from "./callPilot";

export interface NumberContext {
  /** The number the facts are about, normalized by the server. */
  number: string;
  /** Null when the number is unknown, or when it reaches more than one company. */
  companyName: string | null;
  facts: PilotFact[];
  /** True = somebody here has spoken to them before. Changes the opening line. */
  hadContact: boolean;
  /** A scan exists but is too weak to quote - worth admitting, not showing. */
  scanUncertain: boolean;
}

export function getPhoneContext(number: string): Promise<NumberContext> {
  return api.get(`/admin/crm/phone-context?number=${encodeURIComponent(number)}`);
}
